<template>
    <div class="article-grid-view">
      <a-row :gutter="22" v-if="searchingArticles">
        <a-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
          v-for="index in 12"
          :key="index"
        >
          <article-card-skeleton></article-card-skeleton>
        </a-col>
    </a-row>
    <template v-else>
    <div v-if="$store.getters['discover/getLimitError']" class="message">
      <span>Due to multiple access attempts, access in not available for 10 minutes. <br> Subscribe to experience the News SuperIntelligence environment.</span>
      <a-button @click="showSubscriptionModal()">Subscribe</a-button>
    </div>
    <div v-if="articles.length === 0 && !$store.getters['discover/getLimitError']" class="message">
      <span>No results found</span>
      <span v-if="$store.getters['discover/getSearchQuery']"> for <b><q>{{ $store.getters["discover/getSearchQuery"] }}</q></b>
      </span>
    </div>
    <a-row v-else :gutter="[14, 10]">
      <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="article-grid-view-col">
        <a-row :gutter="[14, 14]" class="left-grid">
          <template v-for="(articleIndex, index) in leftGrid"  :key="articleIndex">
            <a-col v-if="articles[articleIndex]?.id.length > 0" :xs="24" :sm="12" :md="leftGridMD24.includes(index) ? 24 : 12" :lg="24" :xl="leftGridXL24.includes(index) ? 24 : 12" >
                <template v-if="leftGridXL24.includes(index)">
                  <article-card
                    v-if="articles[articleIndex]"
                    :title="articles[articleIndex]?.title[0]"
                    :author-name="articles[articleIndex]?.authors[0]"
                    :text="articles[articleIndex]?.description[0]"
                    :image="articles[articleIndex]?.image[0]"
                    :sourceLogo="articles[articleIndex]?.logo[0]"
                    :source="articles[articleIndex]?.article_url.source"
                    :profile-photo="'profile-pic.webp'"
                    :url="articles[articleIndex]?.article_url.url"
                    :id="articles[articleIndex]?.id[0]"
                    :date="articles[articleIndex]?.pub_date[0]"
                    :showShareButton="true"
                    :showDltBtn="showDeleteButton"
                    :showSaveBtn="true"
                    :showUnsaveBtn="showUnsaveButton"
                    :ratings="articles[articleIndex]?.rating"
                    :aggregatedRating="articles[articleIndex]?.aggregated_rating"
                    :userReaction="articles[articleIndex]?.user_reaction"
                    :totalArticleReactions="articles[articleIndex]?.article_reactions"
                    :userReactionRepresentation="articles[articleIndex]?.users_reaction_representation"
                    :isInlineRatingColumn="12"
                    :cardSize="true"
                    :showIconLabel="showLeftGridLabels(index)"
                    :showActNowButton="true"
                  ></article-card> 
                </template>
                <template v-else>
                  <article-card
                    v-if="articles[articleIndex]"
                    :title="articles[articleIndex]?.title[0]"
                    :author-name="articles[articleIndex]?.authors[0]"
                    :text="articles[articleIndex]?.description[0]"
                    :image="articles[articleIndex]?.image[0]"
                    :sourceLogo="articles[articleIndex]?.logo[0]"
                    :source="articles[articleIndex]?.article_url?.source"
                    :profile-photo="'profile-pic.webp'"
                    :url="articles[articleIndex]?.article_url.url"
                    :id="articles[articleIndex]?.id[0]"
                    :date="articles[articleIndex]?.pub_date[0]"
                    :showShareButton="true"
                    :showDltBtn="showDeleteButton"
                    :showSaveBtn="true"
                    :showUnsaveBtn="showUnsaveButton"
                    :ratings="articles[articleIndex]?.rating"
                    :aggregatedRating="articles[articleIndex]?.aggregated_rating"
                    :userReaction="articles[articleIndex]?.user_reaction"
                    :totalArticleReactions="articles[articleIndex]?.article_reactions"
                    :userReactionRepresentation="articles[articleIndex]?.users_reaction_representation"
                    :showIconLabel="showLeftGridLabels(index)"
                    :showActNowButton="true"
                  ></article-card> 
                </template>
            </a-col>
          </template>
        </a-row>
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="article-grid-view-col article-grid-view-right-col">
        <a-row :gutter="[14, 14]" class="right-grid">
          <template v-for="(articleIndex, index) in rightGrid"  :key="articleIndex">
            <a-col v-if="articles[articleIndex]?.id.length > 0"  :xs="24" :sm="12" :md="rightGridMD24.includes(index) ? 24 : 12" :lg="24" :xl="rightGridXL24.includes(index) ? 24 : 12" >
              <template v-if="rightGridXL24.includes(index)">
                <article-card
                  v-if="articles[articleIndex]"
                  :title="articles[articleIndex]?.title[0]"
                  :author-name="articles[articleIndex]?.authors[0]"
                  :text="articles[articleIndex]?.description[0]"
                  :image="articles[articleIndex]?.image[0]"
                  :sourceLogo="articles[articleIndex]?.logo[0]"
                  :source="articles[articleIndex]?.article_url.source"
                  :profile-photo="'profile-pic.webp'"
                  :url="articles[articleIndex]?.article_url.url"
                  :id="articles[articleIndex]?.id[0]"
                  :date="articles[articleIndex]?.pub_date[0]"
                  :showShareButton="true"
                  :showDltBtn="showDeleteButton"
                  :showSaveBtn="true"
                  :showUnsaveBtn="showUnsaveButton"
                  :ratings="articles[articleIndex]?.rating"
                  :aggregatedRating="articles[articleIndex]?.aggregated_rating"
                  :userReaction="articles[articleIndex]?.user_reaction"
                  :totalArticleReactions="articles[articleIndex]?.article_reactions"
                  :userReactionRepresentation="articles[articleIndex]?.users_reaction_representation"
                  :isInlineRatingColumn="12"
                  :cardSize="true"
                  :showIconLabel="showRightGridLabels(index)"
                  :showActNowButton="true"
                ></article-card> 
              </template>
              <template v-else>
                <article-card
                  v-if="articles[articleIndex]"
                  :title="articles[articleIndex]?.title[0]"
                  :author-name="articles[articleIndex]?.authors[0]"
                  :text="articles[articleIndex]?.description[0]"
                  :image="articles[articleIndex]?.image[0]"
                  :sourceLogo="articles[articleIndex]?.logo[0]"
                  :source="articles[articleIndex]?.article_url.source"
                  :profile-photo="'profile-pic.webp'"
                  :url="articles[articleIndex]?.article_url.url"
                  :id="articles[articleIndex]?.id[0]"
                  :date="articles[articleIndex]?.pub_date[0]"
                  :showShareButton="true"
                  :showDltBtn="showDeleteButton"
                  :showSaveBtn="true"
                  :showUnsaveBtn="showUnsaveButton"
                  :ratings="articles[articleIndex]?.rating"
                  :aggregatedRating="articles[articleIndex]?.aggregated_rating"
                  :userReaction="articles[articleIndex]?.user_reaction"
                  :totalArticleReactions="articles[articleIndex]?.article_reactions"
                  :userReactionRepresentation="articles[articleIndex]?.users_reaction_representation"
                  :showIconLabel="showRightGridLabels(index)"
                  :showActNowButton="true"
                ></article-card> 
              </template>
            </a-col>
          </template>
        </a-row>
      </a-col>
    </a-row>
  </template>
  </div>

  <subscription-modal 
    :visible="visibleSubscriptionModal"
    :visibleSignUp="visibleSubscriptionModal" 
    @closeAccessModal="()=>{visibleSubscriptionModal = false}"
    :footer="null"
  ></subscription-modal>

</template>

<script>
// import SubscriptionModal from "../../components/Auth/AccessModal.vue"
import ArticleCard from "../BaseComponents/ArticleCard.vue"
import ArticleCardSkeleton from "../BaseComponents/ArticleCardSkeleton.vue"
import { defineAsyncComponent } from 'vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    activeSection: String
  },
  components: {
    ArticleCard,
    SubscriptionModal: defineAsyncComponent(() => import('@/components/Auth/AccessModal.vue')),
    ArticleCardSkeleton
  },
  data() {
    return {
      showDeleteButton: false,
      showUnsaveButton: false,
      showSavedArticlesButton: true,
      visibleSubscriptionModal: false,
      leftGridXL24: [0,3,6],
      leftGridMD24: [2,5,8],
      rightGridMD24: [0,3,6],
      rightGridXL24: [2,5,8],
      currentWidth: 0
    };
  },
  computed: {
    ...mapGetters({
      discoverScrollPosition: 'discover/discoverScrollPosition',
      stateActiveTopicTab: 'discover/activeTopicTab',
    }),
    mobileView() {
      return this.$store.getters["discover/getSearchedArticles"];
    },
    desktopSkeleton() {
      const insight = this.$store.getters["discover/getInsightsSkeletonLoader"];
      const news = this.$store.getters["discover/getPDBSkeletonLoader"];
      if (this.activeSection === 'Trending News') {
        return news
      }
      return insight;
    },
    searchingArticles() {
      if (window.innerWidth <= 576) {
        return this.$store.getters["discover/getPDBSkeletonLoader"];
      }
      return this.desktopSkeleton;
    },
    desktopView() {
      const newsArticles = this.$store.getters["discover/getSearchedArticles"];
      const insights = this.$store.getters["discover/getInsights"];
      if(this.activeSection === 'Trending News'){
        return newsArticles
      }
      return insights;
    },
    articles(){
      if(window.innerWidth <= 576){
        return this.mobileView;
      }
      return this.desktopView;
    },
    leftGrid(){
      if (this.currentWidth <= 992){
        return [0,1,2,3,4,5,6,7,8]
      }
      else if (this.currentWidth > 992 && this.currentWidth <= 1200){
        return [0,2,4,6,8,10,12,14,16]
      }
      else {
       return [0,3,4,6,9,10,12,15,16] 
      }
      
    },
    rightGrid(){
      if (this.currentWidth <= 992){
        return [9,10,11,12,13,14,15,16,17]
      }
      else if (this.currentWidth > 992 && this.currentWidth <= 1200){
        return [1,3,5,7,9,11,13,15,17]
      }
      else {
       return [1,2,5,7,8,11,13,14,17]
      }
    },
  },
  watch:{
  '$route':{
      handler(route){
          this.$nextTick(()=>{
              if (this.stateActiveTopicTab === 'Trending news' && !this.searchingArticles){
                window.scrollTo({top:this.discoverScrollPosition , behavior: "smooth"})
              }

          })
      },immediate:true
    },
    searchingArticles:{
      handler(val){
        if (!val && (this.$route.name === "discoverTopicDetails" && this.stateActiveTopicTab !== 'Trending news' )){
           window.scrollTo({top:this.discoverScrollPosition , behavior: "smooth"  })
        }
      }
    },
    articles:{
      handler(articleList){
        if (articleList.length > 0){
          this.fetchTopicAnalysis({articleList})
        }else{
          this.emptyTopicAnalysis()
          this.toggleTopicAnalysisLoader(false)
        }
      }, immediate:true
    }
  },
  mounted(){
    this.currentWidth = window.innerWidth;
    window.addEventListener('resize', ()=>{
      this.currentWidth = window.innerWidth
    })
  },
  methods: {
    ...mapActions({
      fetchTopicAnalysis: 'discover/fetchTopicAnalysis',
      connectTopicAnalysisSocket: 'discover/connectTopicAnalysisSocket',
      toggleTopicAnalysisLoader: 'discover/toggleTopicAnalysisLoader',
      emptyTopicAnalysis: 'discover/emptyTopicAnalysis'
    }),
    showSubscriptionModal(){
      this.visibleSubscriptionModal = true;
      this.$store.commit('profile/setSubscriptionModalVisisblity', false)
    },
    showLeftGridLabels(index){
      // xl breakpoint
      if (this.currentWidth >= 1200){
        if(!this.leftGridMD24.includes(index) && this.leftGridXL24.includes(index))
          return true
        else 
          return false
      }
      // lg breakpoint
      else if(this.currentWidth >= 992 && this.currentWidth < 1200){
        return true
      }
      // md breakpoint
      else if (this.currentWidth >= 768 && this.currentWidth < 992){
        if (this.leftGridMD24.includes(index) && !this.leftGridXL24.includes(index))
          return true
        else 
          return false
      }
       // sm breakpoint
       else if (this.currentWidth >= 576 && this.currentWidth < 768){
        return false
      }
      // xs breakpoint
      else {
        return true
      }
    },
    showRightGridLabels(index){
      // xl breakpoint
      if (this.currentWidth >= 1200){
        if(!this.rightGridMD24.includes(index) && this.rightGridXL24.includes(index))
          return true
        else 
          return false
      }
      // lg breakpoint
      else if(this.currentWidth >= 992 && this.currentWidth < 1200){
        return true
      }
      // md breakpoint
      if (this.currentWidth >= 768 && this.currentWidth < 992){
        if (this.rightGridMD24.includes(index) && !this.rightGridXL24.includes(index))
          return true
        else 
          return false
      }
      // sm breakpoint
      else if (this.currentWidth >= 576 && this.currentWidth < 768){
        return false
      }
      // xs breakpoint
      else {
        return true
      }
    }
  }
};
</script>
<style lang="scss">
.article-grid-view {
  .ant-row {
    margin-bottom: 2rem;
    .article-grid-view-col {
      height: fit-content;
    }
    .article-grid-view-right-col {
      .ant-col-xl-12 {
        .article-card-new {
          &__footer {
            .the-horizontal-reactions-bar {
              &__reactions-bar {
                &--figure {
                  left: 50%;
                  transform: translateX(-50%);
                  @media (max-width: 1199px) {
                    left: 0;
                    transform: none;
                  }
                }
              }
            }
          }
        }
      }
    }
    @include respond(phone-x-small) {
      margin-bottom: 0;
    }
  }
  .article-card {
    height: 100%;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5cb !important;
    padding-bottom: 0.5rem;
  }

  .right-grid {
    height: 100%;
    .card-text {
      text-overflow: ellipsis;
    }
    .card-heading {
      font-size: 1.6rem;
      text-overflow: ellipsis;
    }
  }
  .message {
    font-size: 2rem;
    line-height: normal;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: calc(100vh - 41.3rem);
    @include respond(tab-port) {
      font-size: 2.6rem;
    }
    span {
      text-align: center;
    }
    .ant-btn {
      border: none;
      font-size: 1.6rem;
      font-family: $font-secondary-bold;
      cursor: pointer;
      background-color: $color-primary;
      color: $color-white;
      transition: all 0.2s;
      height: 4rem;
      width: 14rem;
      margin-top: 3rem;
      &:hover,
      &:active,
      &:focus {
        background-color: $color-primary;
        color: $color-white;
        border: none;
      }
      @include respond(tab-port) {
        font-size: 2.2rem;
        width: 17rem;
        height: 6rem;
      }
      span {
        line-height: normal;
      }
    }
  }
  .sidebar-search-filter {
    position: sticky;
    top: 12.6rem;
  }
}
</style>
